import Contact from "../classes/Contact";
var contacts = {
    //contactS
    async patch(contact) {
        if(window.debug)console.log("dao:savecontact:")
        const db = window.firebase.firestore();
        var ref = db.collection("databases/" + window.eid + "/contacts")
        var e = await ref.doc(contact.id.toString()).set(contact)
            .then((docRef) => {
                if(window.debug)console.log("Document successfully updated!" + JSON.stringify(docRef));
                return docRef;
            })
            .catch((error) => {
                console.error("Error writing document: ", error);
            });
        return e;
    },
    async upsert(contact) {
        var d = JSON.parse(JSON.stringify(contact));
        if (d.id) {
            var a = await this.patch(d, window.eid);
            return d;
        }
        var lastId = await this.getLastId(window.eid);

         
        if(lastId)
            d.id =lastId + 1;
        else   
            d.id = 1;
        await this.setLastId(d.id);
        var today = new Date();
        d.createdAt = today.getTime();
        const db = window.firebase.firestore();
        var ref = db.doc("databases/" + window.eid + "/contacts/"+ d.id)
        var e = await ref.set(d)
            .then((docRef) => {
                if(window.debug)console.log("Document successfully added!");
                return docRef;
            })
            .catch((error) => {
                console.error("Error writing document: ", error);
            });
        return d;
    },
    async getLastId() {
        const db = window.firebase.firestore();
        let objects = [];
        var docRef = db.doc(`databases/${window.eid}/`)
        var ans = await docRef.get().then((doc) => {
            if (doc.exists) {
                if(window.debug)console.log("Document data:", doc.data());
                return doc.data();
            } else {
                if(window.debug)console.log("No such document!");
            }
        }).catch((error) => {
            if(window.debug)console.log("Error getting document:", error);
        });
        if (ans)
            return ans.lastContactId;
    },

    async setLastId(value) {
        if(window.debug)console.log("dao:setLastContactId:")
        const db = window.firebase.firestore();

        var ref = db.doc("databases/" + window.eid )
        var e = await ref.update({ lastContactId:value})

        // var docRef = db.collection(`databases/${window.eid}/lastContactId`)
        // var e = await docRef.set(value)
            .then((docRef) => {
                if(window.debug)console.log("Document successfully updated!" + JSON.stringify(docRef));
                return docRef;
            })
            .catch((error) => {
                console.error("Error writing document: ", error);
            });
        return e;

    },

    async getFromId(contactId) {
        contactId = parseInt(contactId);

        if(window.debug)console.log(`getFromId:${contactId}, window:${ window.eid }`)
        const db = window.firebase.firestore();
        let objects = [];
        var ans = await db.collection("databases/" + window.eid + "/contacts").where("id", "==", contactId)
            .get()
            .then((querySnapshot) => {
                querySnapshot.forEach((doc) => {
                    objects.push(
                        doc.data()
                    );
                    if(window.debug)console.log(doc.id, " => ", doc.data());
                });
                for (var a = 0; a < objects.length; a++)
                    if(window.debug)console.log("will return")
                return objects
            })
            .catch((error) => {
                if(window.debug)console.log("Error getting documents: ", error);
                return error;
            });
        if(window.debug)console.log("Try load:" + JSON.stringify(ans))
        var contact ; 
        if (ans.length > 0) {
            contact = new Contact();
            contact = Object.assign(contact , ans[0]);
        }
        return contact;
    },

    async getAll() {
        var user = window.user;
        var profileId = '';
        if(user.profileId)
            profileId = user.profileId;


        if(window.debug)console.log("will get contacts")
        const db = window.firebase.firestore();
        let objects = [];
       //var ref = db.collection("databases/" + window.eid + "/contacts").orderBy("name");
        var ref;
        if(profileId =='admin')
                ref = db.collection("databases/" + window.eid + "/contacts").orderBy("name");
            else 
                //ref = db.collection("databases/" + window.eid + "/deals").orderBy("id", "desc");   
                ref = db.collection("databases/" + window.eid + "/contacts").where("ownerId", "==", user.uid);//;
            
        var ans = await ref
            .get()
            .then((querySnapshot) => {
                querySnapshot.forEach((doc) => {
                    objects.push(
                        doc.data()
                    );
                    if(window.debug)console.log(doc.id, " => ", doc.data());
                });
                for (var a = 0; a < objects.length; a++)

                    if(window.debug)console.log("will return")
                return objects
            })
            .catch((error) => {
                if(window.debug)console.log("Error getting documents: ", error);
                return error;
            });

        ans.sort(function(a, b){
            var nameA = a.name.toUpperCase(); // ignore upper and lowercase
            var nameB = b.name.toUpperCase(); // ignore upper and lowercase
            if (nameA < nameB) {
              return -1;
            }
            if (nameA > nameB) {
              return 1;
            }
          
            // names must be equal
            return 0;
        
        }); 

        return ans;
    },

    async delete(contactId) {
        const db = window.firebase.firestore();
        if(window.debug)console.log("will delete :" + contactId);
        let objects = [];
        var ans = db.collection("databases/" + window.eid + "/contacts").doc(contactId.toString())
            .delete()
            .then(() => {

                if(window.debug)console.log("contact deleted")
                return "ok"
            })
            .catch((error) => {
                if(window.debug)console.log("Error getting documents: ", error);
                return error;
            });
        return ans;
    },

  

}

export default contacts;